<template>

  <div class="error">
    <Error/>
    <PortfolioList/>
  </div>

</template>

<script>

  // @ is an alias to /src
  import Error from '@/components/Error.vue'
  import PortfolioList from '@/components/PortfolioList.vue'

  export default {
    name: 'error',
    components: {
      Error,
      PortfolioList
    }
  }

</script>
